(function () {
  'use strict';

  function storageKey(id) {
    return 'tcb-helpful:' + id;
  }

  function initEngagement(wrap) {
    if (!wrap || wrap.getAttribute('data-tcb-engagement-bound') === '1') return;
    wrap.setAttribute('data-tcb-engagement-bound', '1');

    var id = wrap.getAttribute('data-tcb-engagement-id') || 'hub';
    var readBase = parseInt(wrap.getAttribute('data-tcb-read-base') || '0', 10) || 0;
    var helpfulBase = parseInt(wrap.getAttribute('data-tcb-helpful-base') || '0', 10) || 0;
    var readEl = wrap.querySelector('[data-tcb-read-count]');
    var helpfulEl = wrap.querySelector('[data-tcb-helpful-count]');
    var btn = wrap.querySelector('[data-tcb-helpful-btn]');

    var readCount = readBase + 1;
    try {
      var readKey = 'tcb-reads:' + id;
      var storedReads = parseInt(localStorage.getItem(readKey) || '', 10);
      if (!storedReads || storedReads < readBase) {
        localStorage.setItem(readKey, String(readCount));
      } else {
        readCount = storedReads + 1;
        localStorage.setItem(readKey, String(readCount));
      }
    } catch (e) {
      readCount = readBase + 1;
    }

    if (readEl) {
      readEl.textContent = readCount.toLocaleString() + ' reads';
    }

    if (!btn || !helpfulEl) return;

    var helpfulCount = helpfulBase;
    var voted = false;
    try {
      voted = localStorage.getItem(storageKey(id)) === '1';
      var storedHelpful = parseInt(localStorage.getItem('tcb-helpful-count:' + id) || '', 10);
      if (storedHelpful > helpfulBase) helpfulCount = storedHelpful;
    } catch (e) {}

    helpfulEl.textContent = String(helpfulCount);
    if (voted) {
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('is-voted');
    }

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-pressed') === 'true') return;
      helpfulCount += 1;
      helpfulEl.textContent = String(helpfulCount);
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('is-voted');
      try {
        localStorage.setItem(storageKey(id), '1');
        localStorage.setItem('tcb-helpful-count:' + id, String(helpfulCount));
      } catch (e) {}
    });
  }

  function boot() {
    document.querySelectorAll('[data-tcb-hub-engagement]').forEach(initEngagement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
